import React, { ChangeEvent, CSSProperties, useMemo } from 'react';
import css from './styles.module.css';
import classNames from 'classnames';
import menu from '../menu';
import { useView } from '../hooks/use-view';
import { EditorState, Transaction } from 'prosemirror-state';

type RunFunc = (
  state: EditorState<any>,
  dispatch?: (tr: Transaction<any>) => void,
) => void;

type MenubarHandler = (run: RunFunc, focusAfter: boolean) => void;

type MenubarProps = {
  style?: CSSProperties;
  onClick?: MenubarHandler;
  onUpload?: (e: ChangeEvent<HTMLInputElement>) => Promise<void>;
};

const stylesDefault = {};

const MenubarBtn = ({
  name = '',
  title = '',
  content = <></>,
  onClick,
  onUpload,
  active = state => false,
  enable = state => true,
  component: Component,
  run,
}) => {
  const view = useView();

  const handleClick = React.useCallback(
    event => {
      event.preventDefault();
      onClick?.(run);
    },
    [onClick, run],
  );

  const className = classNames(css.button, {
    [css.active]: view?.state && active(view?.state),
  });

  const props = {
    className,
    onClick: handleClick,
    placeholder: title,
    children: content,
    // disabled: view?.state && !enable(view.state),
  };

  if (Component) {
    return <Component {...props} onUpload={onUpload} />;
  }

  return <button {...props} />;
};

export const Menubar: React.FC<MenubarProps> = ({
  style,
  onClick,
  onUpload,
}) => {
  const allStyles = { ...stylesDefault, ...style };

  const menuEntries = Object.entries(menu);
  return (
    <div className={css.menubar} style={allStyles}>
      {menuEntries.map(([groupKey, group], index) => (
        <span key={groupKey} className={css.group}>
          {Object.entries(group).map(([key, item]) => (
            <MenubarBtn
              key={key}
              name={key}
              onClick={onClick}
              onUpload={onUpload}
              component={undefined}
              {...item}
            />
          ))}
          {index !== menuEntries.length - 1 && (
            <span className={css.separator} />
          )}
        </span>
      ))}
    </div>
  );
};
